
import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

 
 
 
export const TST = ({
  data
}: {
  data: any
}) => {

  const getValue = (value?: string): string => value || "Não informado";

 
  return (
    <div style={{ width: "98%" }}>
      <Panel header="Trabalhista">
        <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          <div>
            <TextField
              label="Documento"
              value={getValue(data.documentoConsultado)}
            />
            <TextField
              label="Certidão"
              value={getValue(data.numeroCertidao)}
            />
          
            <TextField
              label="Possui Processo"
              value={getValue(data.possuiProcesso ? 'Sim' : 'Não')}
            />
            <TextField
              label="Data Expediçã0"
              value={getValue(data.dataExpedicao)}
            />
          </div>
          <div>
            <TextField
              label="Nome"
              value={getValue(data.nome)}
            />
            <TextField
              label="Data Validade"
              value={getValue(
                data.dataValidade
              )}
            />
            <TextField
              label="Status"
              value={getValue(data.status)}
            />
            <TextField
              label="Total Processos"
              value={data.totalProcessos}
            />
          </div>
        </section>
        <br></br>
        <Panel header="Processos">
          <DataTable size="small" value={data.processos} tableStyle={{ minWidth: '50rem' }}>
              <Column field="codigo" header="Código"></Column>
              <Column field="local" header="Local"></Column>
          </DataTable>
        </Panel>
      </Panel>
    </div>
  );
};